import classNames from 'classnames';
import { ReactNode } from 'react';

export type ToggleRowOption = {
  label: string | ReactNode;
  value: number;
  icon?: ReactNode;
  className?: string;
};

interface ToggleRowProps {
  options: ToggleRowOption[];
  selected?: number;
  onSelectionChange?: (value: number) => void;
  className?: string;
}

export default function ToggleRow({ options, selected, onSelectionChange, className }: ToggleRowProps) {
  const handleSelect = (value: number) => {
    onSelectionChange?.(value);
  };

  return (
    <div className={classNames(className, 'inline-flex self-start bg-gray-100 rounded-lg p-1 space-x-1')}>
      {options.map((option, index) => (
        <button
          key={index}
          onClick={() => handleSelect(option.value)}
          data-selected={selected === option.value}
          className={classNames(
            'px-4 py-2 rounded-md font-medium text-sm transition-all duration-200 ease-in-out',
            'data-[selected=true]:bg-white data-[selected=true]:text-gray-900 data-[selected=true]:shadow-sm data-[selected=true]:scale-105',
            'data-[selected=false]:text-gray-600 data-[selected=false]:hover:text-gray-800 data-[selected=false]:hover:bg-gray-50',
            option.className,
          )}
        >
          <span className="inline-flex items-center gap-2">
            {option.icon}
            {option.label}
          </span>
        </button>
      ))}
    </div>
  );
}
